"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePropsStyle = void 0;
var react_1 = require("react");
var globalProps_1 = require("../../utils/globalProps");
var usePropsStyle = function (props) {
    var _a = react_1.useState([
        globalProps_1.propsToStyle(props),
        props.style,
    ]), style = _a[0], setStyle = _a[1];
    react_1.useEffect(function () {
        var newStyle = [
            globalProps_1.propsToStyle(props),
            props.style,
        ];
        setStyle(newStyle);
    }, [props]);
    return style;
};
exports.usePropsStyle = usePropsStyle;
//# sourceMappingURL=usePropsStyle.js.map